import React, { useCallback, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addLicense, getUser, listCompanies, listLicenseTypes } from '../../services/service';
import MenuItem from '@mui/material/MenuItem';
import './ListPageStyles.css'
import VpnKey from '@mui/icons-material/VpnKey';
import { Box } from '@mui/system';
import { APITextField } from '../APITextField';
import { APISelectField } from '../APISelectField';
import { FormDialog } from '../../components/FormDialog';
import { APICheckBoxField } from '../APICheckBoxField';


const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[700],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

// const validationSchema = Yup.object({
//   name: Yup
//     .string('Insira o nome do Modelo da Licença')
//     .required('Campo obrigatório'),
//   durationUnit: Yup.string()
//     .oneOf(['lifetime', 'years', 'months', 'days'])
//     .required('Necessário escolher a unidade da duração!'),
// })

const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}

export default function BtnAddLicense({ onLicenseCreated, sx }) {
  const [licenseTypesData, setLicenseTypesData] = useState(defaultResponse);
  const [companyData, setCompanyData] = useState(defaultResponse);
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);


  const listLicenseTypesFn = useCallback(() => {
    setLoading(true);
    listLicenseTypes(1, 1000)
      .then((response) => {
        setLicenseTypesData(response.data)
      })
      .catch((error) => {
        // TODO: Add an alert notifying the user about this error.
        console.log(error)
      })
      .finally(setLoading(false))
  }, [loading])

  const getCompanyFn = useCallback(() => {
    setLoading(true);
    listCompanies(1, 1000)
      .then((response) => {
        setCompanyData(response.data)
      })
      .catch((error) => {
        getUser({ expand: "company" }).then((res) => {
          setCompanyData({ results: [res.data["company"]] })
        }).catch((error) => {
          console.log(error)
        }).finally(setLoading(false))
      })
      .finally(setLoading(false))
  }, [loading])

  useEffect(() => {
    listLicenseTypesFn()
    getCompanyFn()
  }, [loading])

  const handleClickOpen = () => {
    listLicenseTypesFn()
    getCompanyFn()
    setErrors(undefined);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      description: "",
      company: "",
      license_type: "",
      is_server_type: false,
    },
    // validationSchema: validationSchema,
  })


  const onSubmit = (values) => {
    setLoading(true)
    addLicense(
      formik.values.company,
      formik.values.description,
      formik.values.license_type,
      formik.values.is_server_type,
    ).then((response) => {
      console.log(response['status'])
      if (response.status === 201) {
        handleClose()
        onLicenseCreated()
        formik.resetForm()
      } else {
        console.log(response.data)
      }
    }).catch((err) => {
      setErrors(err.response.data);
    }).finally((resp) => {
      setLoading(false)
    })

  }

  return (
    <Box sx={sx}>
      <ColorButton
        startIcon={<VpnKey />}
        onClick={handleClickOpen}
        size="larger" variant="contained"
        sx={{ padding: 2, width: "100%" }}
      >
        Adicionar licença
      </ColorButton>
      <FormDialog
        title={"Criar Licença"}
        open={open}
        onDismiss={handleClose}
        onSubmit={onSubmit}
        formWidth={500}
        loading={loading}
      >
        <APISelectField
          id="license-company"
          name="company"
          label={"Empresa"}
          style={{ width: "100%" }}
          value={formik.values.company}
          onChange={formik.handleChange}
          disabled={loading}
          errors={errors?.company}
        >
          {companyData.results.map(company => (
            <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
          ))}
        </APISelectField>
        <APITextField
          id="license-type-description"
          label="Descrição"
          name="description"
          multiline
          disabled={loading}
          value={formik.values.description}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.description}
        // style={{ width: "100%", margin: '1rem 0rem' }}
        />
        <APISelectField
          id="license-type"
          name="license_type"
          label="Modelo de Licença"
          // style={{ width: "100%" }}
          value={formik.values.license_type}
          onChange={formik.handleChange}
          disabled={loading}
          errors={errors?.license_type}
        >
          {licenseTypesData.results.map(licenseType => (
            <MenuItem
              value={licenseType.id}
              key={licenseType.id}
              style={{ justifyContent: "space-between" }}
            >
              {licenseType.name}
            </MenuItem>
          ))}
        </APISelectField>
        <APICheckBoxField
          id="is_server_type"
          name="is_server_type"
          label="Servidor de Licenças"
          value={formik.values.is_server_type}
          onChange={formik.handleChange}
          disabled={loading}
          errors={errors?.is_server_type}
        />
      </FormDialog>
    </Box >
  );
}
